import {deptTreeSelect} from "@/api/system/user.js";

const useDictStore = defineStore(
  'dict',
  {
    state: () => ({
      dict: new Array(),
      dictMap: new Object() // 数对象，方便引用
    }),
    actions: {
      // 获取字典
      getDict(_key) {
        if (_key == null && _key == "") {
          return null;
        }
        try {
          for (let i = 0; i < this.dict.length; i++) {
            if (this.dict[i].key == _key) {
              return this.dict[i].value;
            }
          }
        } catch (e) {
          return null;
        }
      },
      // 设置字典 和字典Map
      setDict(_key, value) {
        if (_key !== null && _key !== "") {
          this.dict.push({
            key: _key,
            value: value
          });
          this.dictMap[_key] = {};
          value.forEach((item)=>{
            this.dictMap[_key][item.value] = item;
          })
        }
      },
      // 删除字典
      removeDict(_key) {
        var bln = false;
        try {
          for (let i = 0; i < this.dict.length; i++) {
            if (this.dict[i].key == _key) {
              this.dict.splice(i, 1);
              return true;
            }
          }
        } catch (e) {
          bln = false;
        }
        return bln;
      },
      // 清空字典
      cleanDict() {
        this.dict = new Array();
      }
    }
  })

export default useDictStore
